import { client, authHeaders } from '../../_shared/services/openapiClient';
import type { paths } from '../../../types/schema';

export type BettieFeedPost =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts']['get']['responses'][200]['content']['application/json']['bettieFeedPosts'][number];

export type BettieFeedComment =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments']['get']['responses'][200]['content']['application/json']['bettieFeedComments'][number];

export type GetBettieFeedPostsQuery =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts']['get']['parameters']['query'];
export type GetBettieFeedPostsResponse =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts']['get']['responses'][200]['content']['application/json'];

export type GetBettieFeedPostResponse =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{id}']['get']['responses'][200]['content']['application/json']['bettieFeedPost'];

export type CreateBettieFeedPostBody = NonNullable<
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts']['post']['requestBody']
>['content']['application/json'];
export type CreateBettieFeedPostResponse =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts']['post']['responses'][201]['content']['application/json']['bettieFeedPost'];

export type GetBettieFeedCommentsQuery =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments']['get']['parameters']['query'];
export type GetBettieFeedCommentsResponse =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments']['get']['responses'][200]['content']['application/json'];

export type CreateBettieFeedCommentBody = NonNullable<
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments']['post']['requestBody']
>['content']['application/json'];
export type CreateBettieFeedCommentResponse =
  paths['/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments']['post']['responses'][201]['content']['application/json']['bettieFeedComment'];

export async function getBettieFeedPosts(
  chatRoomId: string,
  query: GetBettieFeedPostsQuery = { page: 1, per_page: 30 }
): Promise<GetBettieFeedPostsResponse> {
  const { data, error } = await client.GET(
    '/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts',
    {
      params: { path: { chat_room_id: chatRoomId }, query },
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie feed posts');
  return data;
}

export async function getBettieFeedPost(
  chatRoomId: string,
  postId: string
): Promise<GetBettieFeedPostResponse> {
  const { data, error } = await client.GET(
    '/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{id}',
    {
      params: { path: { chat_room_id: chatRoomId, id: postId } },
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie feed post');
  return data.bettieFeedPost;
}

export async function createBettieFeedPost(
  chatRoomId: string,
  body: CreateBettieFeedPostBody
): Promise<CreateBettieFeedPostResponse> {
  const { data, error } = await client.POST(
    '/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts',
    {
      params: { path: { chat_room_id: chatRoomId } },
      body,
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response when creating bettie feed post');
  return data.bettieFeedPost;
}

export async function getBettieFeedComments(
  chatRoomId: string,
  postId: string,
  query: GetBettieFeedCommentsQuery = { page: 1, per_page: 50 }
): Promise<GetBettieFeedCommentsResponse> {
  const { data, error } = await client.GET(
    '/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments',
    {
      params: {
        path: { chat_room_id: chatRoomId, bettie_feed_post_id: postId },
        query
      },
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response when getting bettie feed comments');
  return data;
}

export async function createBettieFeedComment(
  chatRoomId: string,
  postId: string,
  body: CreateBettieFeedCommentBody
): Promise<CreateBettieFeedCommentResponse> {
  const { data, error } = await client.POST(
    '/api/v1/bettie/chat_rooms/{chat_room_id}/bettie_feed_posts/{bettie_feed_post_id}/bettie_feed_comments',
    {
      params: { path: { chat_room_id: chatRoomId, bettie_feed_post_id: postId } },
      body,
      headers: authHeaders()
    }
  );

  if (error) throw error;
  if (!data) throw new Error('Empty response when creating bettie feed comment');
  return data.bettieFeedComment;
}
